module.exports = __webpack_public_path__ + "img/4M57.0a8d04fd.gif";